function PersonCard({ person, viewMode, previewFields, previewTags, onClick }) {

  // console.log("PreviewTags in PersonCard:", previewTags); // Add this log
  // console.log("Tags for person:", person.tags);
  const isListView = viewMode === "list";

  return (
    <div
      onClick={onClick}
      style={{
        display: "flex",
        flexDirection: isListView ? "row" : "column",
        alignItems: isListView ? "center" : "unset",
        backgroundColor: "#fff",
        borderRadius: "8px",
        padding: isListView ? "10px 15px" : "10px",
        textAlign: isListView ? "left" : "center",
        cursor: "pointer",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        marginBottom: "15px",
        width: isListView ? "95%" : "160px",
        marginLeft: isListView ? "auto" : "0",
        marginRight: isListView ? "20px" : "0",
      }}
    >
      <img
        src={person.picture || "https://via.placeholder.com/150"}
        alt={person.name}
        style={{
          width: isListView ? "50px" : "95%",
          height: isListView ? "50px" : "160px",
          objectFit: "cover",
          borderRadius: "8px",
          marginRight: isListView ? "15px" : "0",
        }}
      />
      <div
        style={{
          marginTop: isListView ? "0" : "10px",
          textAlign: isListView ? "left" : "center",
        }}
      >
        <h3
          style={{
            fontSize: "1rem",
            color: "#333",
            margin: isListView ? "0" : "10px 0 5px 0",
          }}
        >
          {person.name}
        </h3>
        {previewFields.map((field) => (
          <p key={field} style={{ fontSize: "0.9rem", color: "#666", margin: "0" }}>
            {field}: {person.customFields?.[field] !== undefined ? person.customFields?.[field] : 0}
          </p>
        ))}

        {/* Conditionally render tags if previewTags is true */}
        {previewTags && person.tags?.length > 0 && (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "5px",
              marginTop: "10px",
              justifyContent: isListView ? "start" : "center",
            }}
          >
            {person.tags.map((tag) => (
              <span
                key={tag}
                style={{
                  fontSize: "0.75rem",
                  color: "#555",
                  backgroundColor: "#f5f5f5",
                  border: "1px solid #ddd",
                  borderRadius: "12px",
                  padding: "2px 8px",
                }}
              >
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default PersonCard;
